<div class="row" *ngIf="(quoteOrderLine | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Line Type</label>
            </div>
            <div class="col-sm-9">
                <select name="quoteOrderLineType" [(ngModel)]="quoteOrderLine.quoteOrderLineTypeID" class="form-select" required>
                    <option *ngFor="let lineType of quoteOrderLineTypeList" value="{{lineType.quoteOrderLineTypeID}}">{{lineType.abbrev}} - {{lineType.description}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Price</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="quoteOrderLine.price" (change)="calcAmount()" min="0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Cost</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="quoteOrderLine.cost" min="0" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Final Cost</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="quoteOrderLine.finalCost" min="0" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Weekly Frequency</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="quoteOrderLine.frequency" min="0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Do Not Track</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" name="isDoNotTrack" id="isDoNotTrack" style="cursor: pointer;margin: 10px; transform: scale(1.5);" [(ngModel)]="quoteOrderLine.isDoNotTrack" [disabled]="!isCRMAdmin || quoteOrderLine.carrierID > 0" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="fw-bold">Excluded From Dep Automation</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" name="isExcludedFromDepartureAutomation" id="isExcludedFromDepartureAutomation" style="cursor: pointer;margin: 10px; transform: scale(1.5);" [(ngModel)]="quoteOrderLine.isExcludedFromDepartureAutomation" />
            </div>
        </div>
        <div class="row" *ngIf="searchQuoteOrder.opportunityLaneQuoteOrderID > 0">
            <div class="col-sm-3">
                <label class="fw-bold">Auto Tender</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" name="isAutoTender" id="isAutoTender" style="cursor: pointer;margin: 10px; transform: scale(1.5);" [(ngModel)]="quoteOrderLine.isAutoTender" [disabled]="!isCRMAdmin" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">External Tracking Link</label>
                <input type="text" [(ngModel)]="quoteOrderLine.externalTrackingLink" class="form-control" placeholder="eg. https://www.google.com" (keyup)="isValidUrl(quoteOrderLine.externalTrackingLink)" />
            </div>
        </div>
        <!--<div class="row" *ngIf="quoteOrderLine.isAutoTender == true">
        <div class="col-sm-3">
            <label class="fw-bold">Macropoint Required</label>
        </div>
        <div class="col-sm-9">
            <input type="checkbox" name="isMacropointRequired" id="isMacropointRequired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" [(ngModel)]="quoteOrderLine.isMacropointRequired" [disabled]="!isCRMAdmin" />
        </div>
    </div>-->
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="save()" [disabled]="!canSave()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
